import { initScroll } from './scroll';
import { initShowMore } from './toggle/show-more';
import { initShowOnClick } from './toggle/show-on-click';
import { initTimeline } from './widgets';

export * from '.';

/**
 * Initializes all 'plain' (vanilla or jQuery) javascript plugins.
 */
export function initStatics() {
  // NOTE: don't initialize pageslider from here, because it is lazy loaded

  initScroll();
  initShowMore();
  initShowOnClick();
  initTimeline();
}
